import React, { useState, useEffect, memo, useRef } from "react";
import icons from "../../icons";
import { useDispatch, useSelector } from "react-redux";
import { aaaChecked } from "../../redux/reducers/ContrastSlice";
import { Link, useNavigate } from "react-router-dom";
import { logoutFunc } from "../../services/authApiRoutes/APImethods";
import Cookies from "universal-cookie";
import { reduxLogout } from "../../redux/reducers/ContrastSlice";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import Constants from "../../Constants";
import GlobalSearch from "./GlobalSearch";
import { getLoggedInUserRole, projectCreationSteps } from "../../services/Util";
import { rolePermissionSelected } from '../../redux/reducers/RolePermissionSlice';
import { useTour } from "@reactour/tour";
import APIUrls from "../../services/APIUrls";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import { updateCustomerBootstrapData } from "../../redux/reducers/CustomerBootstrapDataSlice";
import { handleError } from "../../services/authApiRoutes/APImethods";
import Notifications from "./Notifications";
import ReactTooltip from "react-tooltip";
import { ConditionalBlock } from "../../ConditionalBlock";
import { initializePendo } from '../../redux/reducers/LoginSessionSlice';

const Header = React.forwardRef((props, refer) => {
  const { t } = useTranslation();
  const translate = t;
  const cookies = new Cookies();
  // const [username, setUsername] = useState("");
  const [togglePop, togglePopoverBody] = useState(false);
  const [increaseTextSizeDisable, setIncreaseTextSizeDisable] = useState(false);
  const [decreaseTextSizeDisable, setDecreaseTextSizeDisable] = useState(false);
  const navigate = useNavigate();
  const userDetailFocus = useRef(null);
  const openUserDetail = (event) => { togglePop ? togglePopoverBody(false) : togglePopoverBody(true);};
  const userDetailRedux = useSelector((loginSessionDetail) => loginSessionDetail.loginSession).value;
  const initPendo = useSelector((loginSessionDetail) => loginSessionDetail.loginSession).initPendo;
  const projectCreationStep = useSelector(reduxStore => reduxStore.project_creation_step).value;
  
   const displayHelpCenterOptions = (event) => {
    var helpCenter = event.target.closest(".help-center");
    if(helpCenter.classList.contains("open")) {
      helpCenter.classList.remove("open");
      $("#help-center-btn").attr('aria-expanded', 'false');
    } else {
      helpCenter.classList.add("open");
      $("#help-center-btn").attr('aria-expanded', 'true');
    }
   }

   const openUserDesc = (e) =>{
     if (e.key === Constants.ENTER || ($('#user-login').hasClass('open') && e.key === Constants.ESCAPE)) {
      openUserDetail(e);
     }
     if ($(window).width() < 768) {
        if($("#user-login").hasClass("open")){
          if (document.activeElement.id === 'user_mgmt') {
            if (e.key === Constants.TAB && !e.shiftKey) {
              e.preventDefault();
              menuClick()
              $("#hideMobileFocus").trigger("focus");
            }
          }
        }
        else{
          if (e.key === Constants.TAB && !e.shiftKey) {
            e.preventDefault();
            menuClick()
            $("#hideMobileFocus").trigger("focus");
          }
        }
        
     }
   }

   const openHelpCenter = (e) =>{
    if (e.key === Constants.ENTER || ($('#help-center').hasClass('open') && e.key === Constants.ESCAPE)) {
      displayHelpCenterOptions(e);
    }
    if ($(window).width() < 768) {
       if($("#help-center").hasClass("open")){
        if (e.key === Constants.TAB && !e.shiftKey) {
          e.preventDefault();
          menuClick()
          $("#hideMobileFocus").trigger("focus");
        }
       }
    }
  }
   
  const headerRef = useRef(null);
  
   window.addEventListener("click", ({ target }) => {
    const popup = target.closest(".user-login");
    if (!popup) {
      togglePopoverBody(false);
    }
    const helpCenterPopup = target.closest(".help-center");
    if(!helpCenterPopup) {
      $('#help-center').removeClass('open');
      $("#help-center-btn").attr('aria-expanded', 'false');
    }
  });

  const closeUserDetail = (event) => {
    if (event.keyCode === 27) {
      togglePopoverBody(false);
      $("#user-login").trigger("focus");
    }
  };

 const initializePendoAgent = (data) =>{
    if(window.pendo){
         const lastVisitorId = window.pendo.getVisitorId();
         const pendoFunc = window.pendo.isAnonymousVisitor(lastVisitorId) ? window.pendo.initialize : window.pendo.identify ;
         pendoFunc({
             visitor: {
                 id: 'om-'+data.configEnvironment+'-'+data.user?.userId,
                 email: data.user?.email,
                 full_name: (data.user?.firstName+ ' '+data.user?.lastName),
                 language : data.user?.language,
                 roles: data.roleSet?.displayName,
                 environment : data.configEnvironment
             },
             account: {
                 id: 'om-'+data.configEnvironment+'-'+data.organization?.id,
                 name: data.organization?.name,
                 accounttype: data.organization?.organizationType
             }
         });
     }
 }

  const closeHelpCenter = (event) => {
    if (event.keyCode === 27) {
      event.target.closest(".help-center").classList.remove("open");
      $("#help-center-btn").attr('aria-expanded', 'false');
      $("#help-center").trigger("focus");
    }
  }
  const getCustBootstrapData = () => {
		getAxiosResponse(APIUrls.CUSTOMER_BOOTSTRAP_DATA)
		.then((res)=>{
			let bootstrapData = res.data?.data;
      if(bootstrapData){
        dispatch(updateCustomerBootstrapData(bootstrapData))
        if(initPendo){
            initializePendoAgent(bootstrapData);
            dispatch(initializePendo(false));
        }
      }
		}).catch(err => {
			handleError(err);
		})
	}

  useEffect(() => {
    getPermissionRole()
    getCustBootstrapData()
  },[]);

  useEffect(() => {
    var increment = document.getElementById("increase-text");
    var decrement = document.getElementById("decrease-text");
    var reset = document.getElementById("reset");
    var fsize = document.getElementById("container");
    var step = 5;
    fsize.style.fontSize = "100%";
    increment.onclick = (event) => {
      $('#reset').removeClass('active')
      $('#decrease-text').removeClass('active')
      $('#increase-text').addClass('active')
      $('#reset').attr('aria-label', 'Default font size')
      if (!event.target.classList.contains("disable-textsize")) {
        fsize.style.fontSize = parseInt(fsize.style.fontSize) + step + "%";
        var textVal = document.getElementById("container").style.fontSize;
        $('#increase-text').attr('aria-label', 'increase font size ' + textVal)
        
        setDecreaseTextSizeDisable(false);
          decrement.classList.remove("disable-textsize");
        if (textVal === "130%") {
          setIncreaseTextSizeDisable(true);
          increment.classList.add("disable-textsize");
          reset.focus();
          $('#decrease-text').attr('aria-label', 'Reduce font size')
          $('#increase-text').attr('aria-label', 'increase font size')
          
         }
      }
    };

    decrement.onclick = (event) => {
      $('#reset').removeClass('active')
      $('#increase-text').removeClass('active')
      $('#decrease-text').addClass('active')
      $('#reset').attr('aria-label', 'Default font size')
      if (!event.target.classList.contains("disable-textsize")) {
        fsize.style.fontSize = parseInt(fsize.style.fontSize) - step + "%";
        var textVal = document.getElementById("container").style.fontSize;
        $('#decrease-text').attr('aria-label', 'Reduce font size ' + textVal)
        setIncreaseTextSizeDisable(false);
        increment.classList.remove("disable-textsize");
        if (textVal === "85%") {
          setDecreaseTextSizeDisable(true);
          decrement.classList.add("disable-textsize");
          reset.focus();
          $('#decrease-text').attr('aria-label', 'Reduce font size')
          $('#increase-text').attr('aria-label', 'increase font size')
          
        }
      }
    };

    reset.onclick = () => {
      $('#reset').addClass('active')
      $('#increase-text').removeClass('active')
      $('#decrease-text').removeClass('active')
      $('#reset').attr('aria-label', 'Default font size selected')
      fsize.style.fontSize = "100%";
      var textVal = document.getElementById("container").style.fontSize;
      if (textVal === "100%") {
        $('#decrease-text').attr('aria-label', 'Reduce font size')
        $('#increase-text').attr('aria-label', 'increase font size')
        setIncreaseTextSizeDisable(false);
        setDecreaseTextSizeDisable(false);
        decrement.classList.remove("disable-textsize");
        increment.classList.remove("disable-textsize");
      }
    };
  },[]);

  const colorContrastStateRedux = useSelector(
    (aaaChecked) => aaaChecked.contrast
  ).value;
 

  const userInitials =
    userDetailRedux !== undefined && userDetailRedux !== ""
      ? userDetailRedux.firstName.charAt(0).toUpperCase() +
        userDetailRedux.lastName.charAt(0).toUpperCase()
      : "NA";

  const userName = userDetailRedux.firstName + " " + userDetailRedux.lastName;

  function leftList() {
    var element = document.getElementById("left-list");
    element.classList.toggle("expand-left");
    var element1 = document.getElementById("openHeader-Menu");
    element1.classList.toggle("expand-header");
    document
      .getElementById("openHeader-Menu")
      .classList.remove("expand-right-menu");
      $('.hamburger-menu').attr('aria-expanded', function(index, attr){
        return attr === 'true' ? 'false': 'true';
      });
      if($('.hamburger-menu').attr('aria-expanded')==='true'){
        $('.visibleHidden').attr('tabindex', '0');
      }
      else{
        $('.visibleHidden').attr('tabindex', '-1');
      }
    }



  if (colorContrastStateRedux) {
    document.body.classList.add("color-contrast");
  } else {
    document.body.classList.remove("color-contrast");
  }
  const dispatch = useDispatch();

  function menuClick() {
    $('.right-hamburger-menu').attr('aria-expanded', function(index, attr){
      return attr === 'true' ? 'false': 'true';
    });
    
    var element = document.getElementById("openHeader-Menu");
    element.classList.toggle("expand-right-menu");
    document
      .getElementById("openHeader-Menu")
      .classList.remove("expand-header");
    document.getElementById("left-list").classList.remove("expand-left");
    if ($('.addRightBlock').length) {
      $('.right-block').removeClass('addRightBlock');
    } else {
      $('.right-block').addClass('addRightBlock');
    }
    if ($(window).width() < 768) {
      if($('.right-hamburger-menu').attr('aria-expanded')==='true'){
        $('.visibleHidden').attr('tabindex', '0');
      }
      else{
        $('.visibleHidden').attr('tabindex', '-1');
      }
    }
  }
  const rightOpenMenu = (event) => {
    if($(".visibleHidden").hasClass("addRightBlock")){
      if ($(window).width() < 768) {
       if (event.key === Constants.TAB) {
         $('.addRightBlock').trigger('focus')   
       }
     }
    }
    if ($(window).width() < 768) {
      if (event.key === Constants.ESCAPE) {
        $(".right-block").removeClass("addRightBlock");
        $("#openHeader-Menu").removeClass("expand-right-menu");
        $('.right-hamburger-menu').attr('aria-expanded', function(index, attr){
          return attr === 'true' ? 'false': 'true';
        });
        if($('.right-hamburger-menu').attr('aria-expanded')==='true'){
          $('.visibleHidden').attr('tabindex', '0');
        }
        else{
          $('.visibleHidden').attr('tabindex', '-1');
        }
      }
    }
  }

  $(window).resize(function() {
    if ($(window).width() > 769) {
      $('.right-hamburger-menu').attr('aria-expanded','false');
      $('#user-login').attr('aria-expanded','false');
      $('#user-login').removeClass('open')
    }
    if ($(window).width() > 767) {
      if ($('.addRightBlock').length) {
        $('.right-block').removeClass('addRightBlock');
      }
      if ($('.expand-right-menu').length) {
        $('#openHeader-Menu').removeClass('expand-right-menu');
      } 
    }
    if ($(window).width() < 769) {
      $('body').removeClass('headerStatic');
      $('body').removeAttr('style');
    }
  });
  const handleModalFocus = (event) => {
    if (document.activeElement.id === 'FirstLink') {
      if (event.key === Constants.TAB && event.shiftKey) {
        event.preventDefault();
        openUserDetail()
        $("#user-login").trigger("focus");
      }
    }
    if ($(window).width() > 769) {
      if (document.activeElement.id === 'logoutFocus') {
        if (event.key === Constants.TAB && !event.shiftKey) {
          event.preventDefault();
          $("#user-login").trigger("focus");
        }
      }
     }
     if ($(window).width() < 768) {
      if($("#user-login").attr("aria-expanded", "true")){
        if (document.activeElement.id === 'user_mgmt') {
          if (event.key === Constants.TAB && !event.shiftKey) {
            event.preventDefault();
            openUserDetail()
            $("#user-login").trigger("focus");
           }
        }
      }
     }
    
  }
  const leftNavkeyDown = (event) => {
    if ($(window).width() < 768) {
    if($(".visibleHidden").hasClass("expand-left")){
        if (event.key === Constants.TAB && !event.shiftKey) {
          $("#left-list").trigger("focus");
         }
         if (event.key === Constants.ESCAPE) {
           $(".hamburger-menu").trigger("focus");
           leftList()
         }
    }
   }
  }
  
  const handlingRightMenuBar = (event) => {
   
      const globalSearchInput = $('#openHeader-Menu.expand-right-menu #globalSearchDropdown input:first');
      if (event.key === Constants.ESCAPE) {
        
      if ($('#user-login').hasClass('open')) {
        openUserDetail(event);
       } else if (globalSearchInput.is(':focus') && globalSearchInput.attr('aria-expanded') === 'true') {
        return;
      } else {
       menuClick();
        $('.right-hamburger-menu').trigger('focus');
      }
    }
    if ($('#openHeader-Menu.expand-right-menu').length) {
        if (globalSearchInput.is(':focus') && event.key === Constants.TAB && event.shiftKey) {
        event.preventDefault();
        menuClick();
        $('.right-hamburger-menu').trigger('focus');
        }
    }
   }

  function colorContrastAAA(e) {
    dispatch(aaaChecked(e.target.checked));
  }
  function colorContrastKeydown(e) {
    if (e.key === Constants.ENTER) {
       dispatch(aaaChecked(e.target.checked));
    }
  }
  

  function logout(e) {
    if (e.type === "click" || e.keyCode === 13) {
      navigate("/logout");
    }
    if ((e.keyCode === 9 && e.shiftKey === false) || e.keyCode === 40) {
      togglePopoverBody(false);
    }
  }

  const submitTicket = (e) => {
    if ((e.keyCode === 9 && e.shiftKey === false) || e.keyCode === 13) {
      displayHelpCenterOptions(e);
    }
  }

  const helpCenterKeydown = (e) => {
    if ((e.keyCode === 9 && e.shiftKey === true) || e.keyCode === 13) {
      displayHelpCenterOptions(e);
    }
  }

  const executeScroll = (e) => {
    if (document.getElementsByTagName('body')[0].classList.contains('color-contrast')) {
      if (e.key === "Enter") {
        if (document.getElementsByClassName('lastdisable').length) {
          document.getElementsByClassName('lastdisable')[0].focus();
        } else if (document.getElementById('projectBtn')) {
          document.getElementById('projectBtn') .focus();
        }
      }
      if (e.type === "click") {
        if (document.getElementsByClassName('lastdisable').length) {
          document.getElementsByClassName('lastdisable')[0].focus();
        } else if (document.getElementById('projectBtn')) {
          document.getElementById('projectBtn') .focus();
        }
      } 
    } else {
      if (e.key === "Enter" && refer !== null) {
        refer.current.focus();
        refer.current.scrollIntoView();
      }
      if (e.type === "click" && refer !== null) {
        refer.current.focus();
        refer.current.scrollIntoView();
      }
    }
  };


  const getPermissionRole = () => {
  
    getAxiosResponse(APIUrls.USER_PERMISSIONS)
    .then((res)=>{
        let permissions = res.data?.permissions ? res.data?.permissions : [];
        dispatch(rolePermissionSelected(permissions));
    }).catch(err => {
        handleError(err);
    })

  }

  const getPermissionsRedux = useSelector(
    (rolePermissionSelected) => rolePermissionSelected.role_permission,
  ).value;

  $(document).mouseup(function (e) {
    var bannerCont = $('.search-result');
    if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
      $('.search').removeClass('open');
    }
  });
  
  
  const { setIsOpen } = useTour();
  $(document).on("click",".tutorial-next",function() {
    $('body').removeClass('modal-tutorial');
    $('body').removeClass('modal-open-2');
    $('body').removeClass('modal-open-3');
    $('body').removeClass('modal-open-4');
    $('body').removeClass('modal-open-5');
    $('body').removeClass('modal-open-6');
    $('body').addClass('headerStatic');
  });
  $(document).on("click",".reactour__close-button",function() {
    $('body').removeClass('headerStatic');
  });
  if ($('.tutorial-right-arr').hasClass('tutorial-disable')){
     $('body').addClass('headerStatic');
  }
  $(document).on("click",".tutorial-disable",function() {
    $('body').removeClass('headerStatic');
  });
  const hideModalTutorial = () =>{
    document.body.classList.remove("modal-tutorial");
    document.body.classList.remove("modal-open-2");
    document.body.classList.remove("modal-open-3");
    document.body.classList.remove("modal-open-4");
    document.body.classList.remove("modal-open-5");
    document.body.classList.remove("modal-open-6");
  }
  $(document).on("click",".tutorial-tips button",function() {
    $(this).addClass('focusAdd');
  });
  $(document).on("click",".modal-footer .modalCancelFocus",function() {
   $('.focusAdd').trigger('focus');
   $('.tutorial-tips').removeClass('focusAdd');
  });
  $(document).on("click",".reactour__close-button, .finish-btn",function() {
    $('.focusAdd').trigger('focus');
    $('.tutorial-tips').removeClass('focusAdd');
   });
  
  $(window).on('popstate', function() {
   for(let i=2; i<=6; i++){
    $('body').removeClass('modal-open', 'modal-open-' + i);
    }
  });
  $(document).on("click",".tutorial-next",function() {
    setTimeout(() => {
      $(".reactour__close-button").on("keydown", function (e) {
        if (e.key === Constants.TAB && e.shiftKey) {
          e.preventDefault();
          if($('.tutorial-left-arr').prop('disabled')){
            $(".tutorial-right-arr, .finish-btn").trigger("focus");
          }
          else{
           $(".tutorial-right-arr, .finish-btn").trigger("focus");
          }
      }
      });
      $(".reactour__popover").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          setIsOpen(false)
          $('.focusAdd').trigger('focus');
        }
      });
    },500)
  });
  $(".tutorial-right-arr").on("keydown", function (e) {
    if (e.key === Constants.TAB && !e.shiftKey) {
        e.preventDefault();
        $(".reactour__close-button").trigger("focus");
    }
  });
  const asyncAssetUploadInfo = useSelector(reduxStore => reduxStore.asset_upload_background).value;
  
 return (
    <>
      <div role="link" tabIndex={0} onClick={executeScroll} onKeyDown={(e) => executeScroll(e)} className="skip" >
        <span>Skip to Main Content</span>
      </div>
      <header id="openHeader-Menu" className="header flex-center" ref={headerRef} >
        <button className="hamburger-menu hide mshow" onClick={leftList}
        aria-label="Main menu" aria-expanded="false" onKeyDown={(e) => leftNavkeyDown(e)}  >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="logo">
          <Link to={"/home"} aria-label="home page">
            <img src={colorContrastStateRedux?icons.LOGO_AA:icons.LOGO} alt="Logo" />
          </Link>
        </div>
        <div className="flex-center mobileShow">
        <button className="right-hamburger-menu hide mshow" id="hideMobileFocus" onClick={menuClick}
         onKeyDown={(e) => rightOpenMenu(e)} aria-label="More options" aria-expanded="false" >
          <span></span>
          <span></span>
          <span></span>
        </button>
         <div className="user-list"
            onClick={(e) => {
              logout(e);
            }}
            onKeyDown={(e) => {
              logout(e);
            }}
            >
            <Link to="#" aria-label="sign out">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" > <g clipPath="url(#clip0_1325_5798)"> <path d="M9.89844 3.28125V2.1875C9.89844 0.981277 8.91716 0 7.71094 0H2.21484C1.00862 0 0.0273438 0.981277 0.0273438 2.1875V11.8125C0.0273438 13.0187 1.00862 14 2.21484 14H7.71094C8.91716 14 9.89844 13.0187 9.89844 11.8125V10.7188C9.89844 10.4167 9.65363 10.1719 9.35156 10.1719C9.0495 10.1719 8.80469 10.4167 8.80469 10.7188V11.8125C8.80469 12.4156 8.314 12.9062 7.71094 12.9062H2.21484C1.61179 12.9062 1.12109 12.4156 1.12109 11.8125V2.1875C1.12109 1.58444 1.61179 1.09375 2.21484 1.09375H7.71094C8.314 1.09375 8.80469 1.58444 8.80469 2.1875V3.28125C8.80469 3.58331 9.0495 3.82812 9.35156 3.82812C9.65363 3.82812 9.89844 3.58331 9.89844 3.28125ZM13.6269 7.93941L12.4023 9.164C12.1887 9.37762 11.8424 9.37762 11.6289 9.164C11.4153 8.95049 11.4153 8.6042 11.6289 8.39069L12.4999 7.51953H5.93359C5.63153 7.51953 5.38672 7.27472 5.38672 6.97266C5.38672 6.67059 5.63153 6.42578 5.93359 6.42578H12.4999L11.6289 5.55463C11.4153 5.34111 11.4153 4.99483 11.6289 4.78131C11.7357 4.6745 11.8756 4.62109 12.0155 4.62109C12.1556 4.62109 12.2955 4.6745 12.4023 4.78131L13.6269 6.00591C14.16 6.539 14.16 7.40631 13.6269 7.93941Z" fill="#2A4274" /> </g> <defs> <clipPath id="clip0_1325_5798"> <rect width="14" height="14" fill="white" transform="matrix(1 0 0 -1 0 14)" /> </clipPath> </defs> </svg>
            </Link>
          </div>
        </div>
        <div className="right-block flex-center visibleHidden" onKeyDown={(e)=>handlingRightMenuBar(e)} >
          <GlobalSearch />
          <div className="flex-center right-side">
            <div className="textsize-block">
              <button type="button" className="textsizeBtn"
                value="75" id="decrease-text" aria-label="Reduce font size" disabled={decreaseTextSizeDisable} >
                A-
              </button>
              <button type="button" className="textsizeBtn active"
                value="100" id="reset" aria-label="Default font size selected" >
                A
              </button>
              <button type="button" className="textsizeBtn" value="140"
                id="increase-text" aria-label="Increase font size" disabled={increaseTextSizeDisable} >
                A+
              </button>
            </div>
            <div id="help-center" className="help-center flex-center">
              <button id="help-center-btn" aria-label="Help Center" onKeyDown={(e) => openHelpCenter(e)} aria-expanded="false" onClick={(e) => displayHelpCenterOptions(e)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 91 92" fill="#64748B">
                  <path d="M45.385,0.004C19.982,0.344-0.334,21.215,0.004,46.619c0.34,25.393,21.209,45.715,46.611,45.377  c25.398-0.342,45.718-21.213,45.38-46.615C91.655,19.986,70.785-0.335,45.385,0.004z M45.249,74l-0.254-0.004  c-3.912-0.116-6.67-2.998-6.559-6.852c0.109-3.788,2.934-6.538,6.717-6.538l0.227,0.004c4.021,0.119,6.748,2.972,6.635,6.937  C51.903,71.346,49.122,74,45.249,74z M61.704,41.341c-0.92,1.307-2.943,2.93-5.492,4.916l-2.807,1.938  c-1.541,1.198-2.471,2.325-2.82,3.434c-0.275,0.873-0.41,1.104-0.434,2.88l-0.004,0.451H39.429l0.031-0.907  c0.131-3.728,0.223-5.921,1.768-7.733c2.424-2.846,7.771-6.289,7.998-6.435c0.766-0.577,1.412-1.234,1.893-1.936  c1.125-1.551,1.623-2.772,1.623-3.972c0-1.665-0.494-3.205-1.471-4.576c-0.939-1.323-2.723-1.993-5.303-1.993  c-2.559,0-4.311,0.812-5.359,2.478c-1.078,1.713-1.623,3.512-1.623,5.35v0.457H27.935l0.02-0.477  c0.285-6.769,2.701-11.643,7.178-14.487C37.946,18.918,41.446,18,45.53,18c5.346,0,9.859,1.299,13.412,3.861  c3.6,2.596,5.426,6.484,5.426,11.556C64.368,36.254,63.472,38.919,61.704,41.341z"/>
                </svg>
                <div className="triangle-with-shadow"></div>
              </button>
              <div className="popover-body">
                <div className="inner-popover" onKeyDown={(e) => {closeHelpCenter(e);}}>
                  <div className="user-list">
                    <a tabIndex="0" href="https://adapt-studio.zendesk.com/hc/en-us" target="_blank" onClick={(e) => displayHelpCenterOptions(e)} onKeyDown={(e) => helpCenterKeydown(e)}>
                    {translate("dashboard.help_center")}
                    </a>
                  </div>
                  <div className="user-list">
                    <a tabIndex="0" href="https://adapt-studio.zendesk.com/hc/en-us/community/topics/200174493-Questions-Answers" target="_blank" onClick={(e) => displayHelpCenterOptions(e)}>
                    {translate("dashboard.ques_ans")}
                    </a>
                  </div>
                  <div className="user-list">
                    <a tabIndex="0" href="https://adapt-studio.zendesk.com/hc/en-us/requests/new" target="_blank" onClick={(e) => displayHelpCenterOptions(e)} onKeyDown={(e) => submitTicket(e)}>
                    {translate("dashboard.submit_ticket")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="tutorial-tips">
              {props.func && <button onClick={props.func} aria-label="help">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="128.000000pt" height="128.000000pt" viewBox="0 0 128.000000 128.000000" preserveAspectRatio="xMidYMid meet">
                  <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)" fill="#2A4274" stroke="none">
                  <path d="M118 1260 c-24 -13 -46 -36 -59 -61 -19 -37 -20 -55 -17 -207 3 -158 4 -169 27 -201 38 -53 70 -61 245 -61 103 0 157 4 162 11 13 22 -24 29 -173 29 l-153 0 -32 29 -33 29 0 176 0 176 27 27 c25 24 37 28 110 33 65 4 83 8 83 20 0 25 -140 25 -187 0z"/>
                  <path d="M342 1263 c3 -17 32 -18 400 -23 l398 -5 27 -28 28 -27 0 -175 0 -175 -28 -27 -27 -28 -213 -5 c-191 -5 -212 -7 -215 -22 -3 -17 12 -18 203 -18 230 0 256 5 296 61 23 32 24 43 27 201 3 152 2 170 -17 207 -14 27 -35 48 -61 61 -37 19 -58 20 -430 20 -367 0 -391 -1 -388 -17z"/>
                  <path d="M250 1005 c0 -136 0 -136 23 -133 19 3 22 10 25 61 l3 57 39 0 39 0 3 -57 c3 -50 6 -58 23 -58 19 0 20 7 20 130 0 123 -1 130 -20 130 -17 0 -20 -8 -23 -52 l-3 -53 -39 0 -39 0 -3 53 c-3 45 -6 52 -25 55 -23 3 -23 3 -23 -133z"/>
                  <path d="M474 1127 c-2 -7 -3 -67 -2 -133 l3 -119 83 -3 c77 -3 82 -2 82 18 0 18 -6 20 -61 20 l-60 0 3 38 c3 34 6 37 36 40 19 2 32 9 32 17 0 8 -13 15 -32 17 -30 3 -33 6 -36 41 l-3 37 60 0 c54 0 61 2 61 20 0 18 -7 20 -80 20 -57 0 -82 -4 -86 -13z"/>
                  <path d="M675 1128 c-3 -8 -4 -68 -3 -134 l3 -119 75 0 c60 0 75 3 75 15 0 11 -14 16 -52 18 l-52 3 -3 112 c-3 97 -5 112 -21 115 -9 2 -19 -3 -22 -10z"/>
                  <path d="M854 1127 c-2 -7 -3 -67 -2 -133 3 -115 4 -119 26 -122 20 -3 22 0 22 47 l0 51 40 0 c56 0 90 34 90 89 0 57 -33 81 -112 81 -39 0 -60 -4 -64 -13z m115 -41 c7 -8 11 -27 9 -43 -3 -24 -8 -28 -40 -31 l-38 -3 0 45 c0 44 1 46 29 46 16 0 34 -6 40 -14z"/>
                  <path d="M552 834 c-41 -17 -52 -57 -52 -196 0 -114 -1 -118 -19 -108 -11 5 -35 10 -54 10 -45 0 -91 -50 -84 -89 3 -14 10 -51 15 -81 6 -30 16 -88 22 -128 17 -118 64 -194 142 -227 51 -21 278 -21 337 0 72 25 145 95 122 118 -8 8 -21 2 -49 -25 -59 -58 -94 -68 -237 -68 -135 0 -173 9 -212 51 -38 41 -64 116 -73 208 -5 49 -14 101 -20 115 -16 43 -12 64 15 82 53 35 95 -17 95 -118 0 -66 10 -95 29 -84 8 5 11 81 11 245 0 218 2 239 18 254 23 21 36 21 56 1 13 -13 16 -45 16 -195 0 -172 1 -179 20 -179 18 0 20 7 20 68 0 73 10 92 47 92 30 0 43 -28 43 -90 0 -44 3 -51 18 -48 13 2 18 15 20 56 3 59 26 81 62 62 16 -9 20 -21 20 -65 0 -29 3 -60 6 -69 10 -26 34 -19 34 10 0 54 45 85 78 52 17 -17 16 -203 -3 -263 -15 -50 -13 -65 9 -65 21 0 37 70 43 191 5 95 3 121 -11 147 -17 34 -49 47 -91 40 -15 -3 -25 -1 -25 7 0 6 -11 22 -25 35 -20 19 -31 22 -71 17 -33 -3 -55 0 -71 10 -13 9 -36 13 -52 11 l-29 -4 -4 92 c-2 71 -7 96 -21 112 -24 26 -58 32 -95 16z"/>
                  </g>
                </svg>
              </button>}
              </div>
            <div className="form-switch mar-top6">
             <input
                type="checkbox"
                id="switch"
                value="color-contrast"
                role="switch"
                className="switch"
                aria-label="Dark mode"
                onChange={colorContrastAAA}
                onKeyDown={(e) => colorContrastKeydown(e)}
                defaultChecked={colorContrastStateRedux}
              />
            </div>
            
            <Notifications />
            
            <div id="user-login" className={ togglePop ? "user-login flex-center open" : "user-login flex-center"}
              role="button" aria-label={userName + " , User profile"}
              tabIndex="0" aria-expanded={togglePop} onClick={(e) => openUserDetail(e)}
              onKeyDown={(e) => openUserDesc(e)} data-tour="user-profile" >
              <figure>
                <div className="profileImage">{userInitials}</div>
              </figure>
              <div className="user">
                <strong>{userName}</strong>
              </div>
              <div className="popover-body"  onKeyDown={(e) => handleModalFocus(e)}>
                <div className="triangle-with-shadow"></div>
                <div
                  className="inner-popover"
                  onKeyDown={(e) => {
                    closeUserDetail(e);
                  }}
                >
                  <div className="user-list">
                    <Link id="FirstLink" to="/settings/my-account-profile" ref={userDetailFocus}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <path
                          d="M10.0209 7.17726C10.4404 6.80459 10.7769 6.34362 11.0075 5.82566C11.2381 5.3077 11.3574 4.74488 11.3572 4.17542C11.3572 3.10566 10.9432 2.07971 10.2062 1.32327C9.46915 0.566837 8.46954 0.141876 7.42723 0.141876C6.38493 0.141876 5.38532 0.566837 4.6483 1.32327C3.91127 2.07971 3.49722 3.10566 3.49722 4.17542C3.4971 4.74488 3.61638 5.3077 3.84697 5.82566C4.07755 6.34362 4.41403 6.80459 4.83357 7.17726C3.73328 7.68864 2.79976 8.51443 2.14463 9.5559C1.4895 10.5974 1.14047 11.8105 1.13928 13.0501C1.14537 13.2599 1.23083 13.459 1.37754 13.6051C1.52426 13.7513 1.72068 13.833 1.92515 13.833C2.12961 13.833 2.32603 13.7513 2.47275 13.6051C2.61946 13.459 2.70492 13.2599 2.71101 13.0501C2.71101 11.7665 3.20786 10.5354 4.09226 9.62767C4.97666 8.71997 6.17616 8.21003 7.42689 8.21003C8.67762 8.21003 9.87712 8.71997 10.7615 9.62767C11.6459 10.5354 12.1428 11.7665 12.1428 13.0501C12.1488 13.2599 12.2343 13.459 12.381 13.6051C12.5277 13.7513 12.7242 13.833 12.9286 13.833C13.1331 13.833 13.3295 13.7513 13.4762 13.6051C13.6229 13.459 13.7084 13.2599 13.7145 13.0501C13.7136 11.8109 13.3651 10.598 12.7106 9.55661C12.0561 8.51518 11.1233 7.68916 10.0237 7.17726H10.0209ZM7.42758 6.5969C6.96123 6.5969 6.50534 6.45497 6.11758 6.18905C5.72982 5.92313 5.4276 5.54517 5.24913 5.10296C5.07066 4.66075 5.02397 4.17416 5.11495 3.70472C5.20593 3.23527 5.4305 2.80406 5.76027 2.46561C6.09003 2.12716 6.51018 1.89667 6.96757 1.80329C7.42497 1.70992 7.89907 1.75784 8.32993 1.94101C8.76078 2.12418 9.12904 2.43436 9.38814 2.83234C9.64723 3.23031 9.78552 3.69821 9.78552 4.17685C9.78552 4.49465 9.72453 4.80935 9.60603 5.10296C9.48754 5.39658 9.31385 5.66336 9.0949 5.88808C8.87594 6.11281 8.61601 6.29107 8.32993 6.41268C8.04385 6.5343 7.73723 6.5969 7.42758 6.5969Z"
                          fill="#2A4274"
                          stroke="white"
                          strokeWidth="0.4"
                        />
                      </svg>
                      <span>{translate("header.my_account")}</span>
                    </Link>
                  </div>
                  {getPermissionsRedux.includes('SETTINGS') ? (
                  <div className="user-list">
                    <Link to="/settings">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M15.875 8C15.875 6.89244 15.0701 5.96881 14.0148 5.78375L13.8196 5.31406C14.4356 4.43656 14.3512 3.21537 13.5682 2.43181C12.8111 1.67469 11.5438 1.57625 10.6854 2.17981L10.2157 1.98519C10.0306 0.929938 9.10756 0.125 8 0.125C6.89244 0.125 5.96881 0.929938 5.78375 1.98519L5.31406 2.17981C4.43769 1.565 3.21537 1.64825 2.43181 2.43181C2.00656 2.8565 1.77256 3.42181 1.77256 4.02313C1.77256 4.49169 1.91487 4.93887 2.17981 5.31462L1.98519 5.78375C0.929375 5.96881 0.125 6.89244 0.125 8C0.125 9.10813 0.929938 10.0312 1.98519 10.2163L2.17981 10.6854C1.56444 11.5634 1.64825 12.7846 2.43181 13.5682C3.18781 14.3248 4.45737 14.4238 5.31462 13.8202L5.78431 14.0148C5.96937 15.0701 6.893 15.875 8.00056 15.875C9.10869 15.875 10.0318 15.0701 10.2163 14.0148L10.6859 13.8196C11.5629 14.4356 12.7841 14.3523 13.5687 13.5682C13.994 13.1429 14.228 12.5782 14.228 11.9769C14.228 11.5083 14.0851 11.0611 13.8207 10.6854L14.0154 10.2163C15.0701 10.0318 15.875 9.10869 15.875 8C15.875 8.00056 15.875 8.00056 15.875 8ZM13.625 9.12613C13.3977 9.12613 13.1924 9.26281 13.1053 9.47319L12.6507 10.5689C12.5636 10.7793 12.6119 11.0212 12.7728 11.1821C12.9854 11.3947 13.1024 11.6771 13.1024 11.9774C13.1024 12.2784 12.9854 12.5608 12.7728 12.7734C12.3341 13.2121 11.6191 13.211 11.1815 12.7734C11.0206 12.6125 10.7787 12.5641 10.5684 12.6513L9.47206 13.1058C9.26169 13.193 9.125 13.3983 9.125 13.6256C9.125 14.246 8.62044 14.7506 8 14.7506C7.37956 14.7506 6.875 14.246 6.875 13.6256C6.875 13.3983 6.73775 13.1924 6.52794 13.1058L5.43106 12.6513C5.22012 12.5641 4.97938 12.6125 4.81794 12.7734C4.39269 13.1986 3.65244 13.1986 3.22719 12.7734C2.78844 12.3346 2.78844 11.6208 3.22719 11.1821C3.38806 11.0212 3.43644 10.7793 3.34925 10.5689L2.89475 9.47319C2.80756 9.26281 2.60225 9.12613 2.375 9.12613C1.75456 9.12613 1.25 8.62156 1.25 8.00056C1.25 7.38012 1.75456 6.87556 2.375 6.87556C2.60225 6.87556 2.80756 6.73831 2.89475 6.5285L3.34925 5.43163C3.43644 5.22125 3.38806 4.97937 3.22719 4.8185C3.01456 4.60587 2.89756 4.3235 2.89756 4.02313C2.89756 3.72275 3.01456 3.43981 3.22719 3.22719C3.66594 2.78844 4.37975 2.78844 4.8185 3.22719C4.97937 3.38806 5.22125 3.43531 5.43163 3.34925L6.52794 2.89475C6.73775 2.80756 6.875 2.60225 6.875 2.375C6.875 1.75456 7.37956 1.25 8 1.25C8.62044 1.25 9.125 1.75456 9.125 2.375C9.125 2.60225 9.26225 2.80756 9.47206 2.89475L10.5689 3.34925C10.7793 3.43587 11.0212 3.38862 11.1821 3.22719C11.6073 2.80194 12.3476 2.80194 12.7728 3.22719C13.211 3.66594 13.211 4.37975 12.7728 4.8185C12.6119 4.97937 12.5636 5.22125 12.6507 5.43163L13.1053 6.5285C13.1919 6.73775 13.3977 6.875 13.625 6.875C14.2454 6.875 14.75 7.37956 14.75 8C14.75 8.621 14.2454 9.12613 13.625 9.12613Z"
                          fill="#2A4274"
                        />
                        <path
                          d="M8 5.1875C6.44919 5.1875 5.1875 6.44919 5.1875 8C5.1875 9.55081 6.44919 10.8125 8 10.8125C8.3105 10.8125 8.5625 10.5611 8.5625 10.25C8.5625 9.93894 8.3105 9.6875 8 9.6875C7.06963 9.6875 6.3125 8.93038 6.3125 8C6.3125 7.06963 7.06963 6.3125 8 6.3125C8.93038 6.3125 9.6875 7.06963 9.6875 8C9.6875 8.32737 9.59412 8.64462 9.41694 8.918C9.24762 9.17844 9.32187 9.52662 9.58287 9.69594C9.84331 9.86525 10.1915 9.79156 10.3608 9.53C10.6561 9.07437 10.8125 8.54506 10.8125 8C10.8125 6.44919 9.55081 5.1875 8 5.1875Z"
                          fill="#2A4274"
                        />
                      </svg>
                      <span>{translate("header.settings")}</span>
                    </Link>
                  </div>
                  ) : null }
                  {getPermissionsRedux.includes('USER_MANAGEMENT') ? (
                  <div className="user-list">
                    <Link to="/settings/user-management"
                    id="user_mgmt"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M0.749939 15V14.25C0.749939 11.3505 3.10045 9 5.99994 9C8.89944 9 11.2499 11.3505 11.2499 14.25V15"
                          stroke="#2A4274"
                          strokeLinecap="round"
                        />
                        <path
                          d="M9.74994 10.5C9.74994 8.42895 11.4289 6.75 13.4999 6.75C15.571 6.75 17.2499 8.42895 17.2499 10.5V10.875"
                          stroke="#2A4274"
                          strokeLinecap="round"
                        />
                        <path
                          d="M5.99994 9C7.65676 9 8.99994 7.65683 8.99994 6C8.99994 4.34314 7.65676 3 5.99994 3C4.34308 3 2.99994 4.34314 2.99994 6C2.99994 7.65683 4.34308 9 5.99994 9Z"
                          stroke="#2A4274"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13.5 6.75C14.7427 6.75 15.75 5.74264 15.75 4.5C15.75 3.25736 14.7427 2.25 13.5 2.25C12.2573 2.25 11.25 3.25736 11.25 4.5C11.25 5.74264 12.2573 6.75 13.5 6.75Z"
                          stroke="#2A4274"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span>{translate("header.user_management")}</span>
                    </Link>
                  </div>
                  ) : null }
                  <div
                    className="user-list mhide"
                    // onBlur={(e) => {
                    //   closeUserDetail(e);
                    // }}
                    onClick={(e) => {
                      logout(e);
                    }}
                    onKeyDown={(e) => {
                      logout(e);
                    }}
                  >
                    <Link to="#" aria-label="sign out" id="logoutFocus">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_1325_5798)">
                          <path
                            d="M9.89844 3.28125V2.1875C9.89844 0.981277 8.91716 0 7.71094 0H2.21484C1.00862 0 0.0273438 0.981277 0.0273438 2.1875V11.8125C0.0273438 13.0187 1.00862 14 2.21484 14H7.71094C8.91716 14 9.89844 13.0187 9.89844 11.8125V10.7188C9.89844 10.4167 9.65363 10.1719 9.35156 10.1719C9.0495 10.1719 8.80469 10.4167 8.80469 10.7188V11.8125C8.80469 12.4156 8.314 12.9062 7.71094 12.9062H2.21484C1.61179 12.9062 1.12109 12.4156 1.12109 11.8125V2.1875C1.12109 1.58444 1.61179 1.09375 2.21484 1.09375H7.71094C8.314 1.09375 8.80469 1.58444 8.80469 2.1875V3.28125C8.80469 3.58331 9.0495 3.82812 9.35156 3.82812C9.65363 3.82812 9.89844 3.58331 9.89844 3.28125ZM13.6269 7.93941L12.4023 9.164C12.1887 9.37762 11.8424 9.37762 11.6289 9.164C11.4153 8.95049 11.4153 8.6042 11.6289 8.39069L12.4999 7.51953H5.93359C5.63153 7.51953 5.38672 7.27472 5.38672 6.97266C5.38672 6.67059 5.63153 6.42578 5.93359 6.42578H12.4999L11.6289 5.55463C11.4153 5.34111 11.4153 4.99483 11.6289 4.78131C11.7357 4.6745 11.8756 4.62109 12.0155 4.62109C12.1556 4.62109 12.2955 4.6745 12.4023 4.78131L13.6269 6.00591C14.16 6.539 14.16 7.40631 13.6269 7.93941Z"
                            fill="#2A4274"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1325_5798">
                            <rect
                              width="14"
                              height="14"
                              fill="white"
                              transform="matrix(1 0 0 -1 0 14)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <span>{translate("header.sign_out")}</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ConditionalBlock condition={(props.statusBar &&
          ((asyncAssetUploadInfo?.pendingFiles && Object.keys(asyncAssetUploadInfo?.pendingFiles).length !== 0) || asyncAssetUploadInfo?.isReadyForValidation) && projectCreationSteps.indexOf(projectCreationStep) > 1)}>
            <div className="statusBar"></div>
        </ConditionalBlock>
      </header>
      <div className="tutorial-lightbox lightbox-panel centerPopup" aria-labelledby="tutorial" aria-modal="true" role="dialog">
        <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="tutorial">Tutorial - Dashboard</h5>
            </div>
            <div className="lightbox-content padd-22">
              <p>Dashboards holds information about the current activities of projects and campaigns.<br/>Let's start with projects.</p>
              
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
                <button id="dashboardCancel" className="blue-btn modalCancelFocus cancelFocus" onClick={hideModalTutorial}>Cancel</button>
                <button id="dashboardNext" className="blue-btn tutorial-next nextFocus active" onClick={(e) => setIsOpen(true)} >Next</button> 
            </div>
            
        </div>
      </div>

      <div id="modal-open-2" className="show-desktop lightbox-panel centerPopup" aria-labelledby="tutorialProject" aria-modal="true" role="dialog">
        <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="tutorialProject">Tutorial - Projects</h5>
            </div>
            <div className="lightbox-content padd-22">
              <p>This is the "Projects" tab. All projects are located here</p>
              
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
                <button className="blue-btn modalCancelFocus cancelFocus2" onClick={hideModalTutorial}>Cancel</button>
                <button className="blue-btn tutorial-next nextFocus2 active" onClick={() => setIsOpen(true)}>Next</button> 
            </div>
            
        </div>
      </div>
      <div id="modal-open-3" className="show-desktop lightbox-panel centerPopup" aria-labelledby="tutorialCampaign" aria-modal="true" role="dialog">
        <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="tutorialCampaign">Tutorial - Campaigns</h5>
            </div>
            <div className="lightbox-content padd-22">
              <p>Campaigns are an effective method of tracking multiple projects at once.</p>
             </div>
            <div className="modal-footer modal-footer-border flex px-22">
                <button className="blue-btn modalCancelFocus cancelFocus3" onClick={hideModalTutorial}>Cancel</button>
                <button className="blue-btn tutorial-next nextFocus3 active" onClick={() => setIsOpen(true)}>Next</button> 
            </div>
            
        </div>
      </div>
      <div id="modal-open-4" className="show-desktop lightbox-panel centerPopup" aria-labelledby="tutorialCampaignDetails" aria-modal="true" role="dialog">
        <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="tutorialCampaignDetails">Tutorial - Campaign Details</h5>
            </div>
            <div className="lightbox-content padd-22">
              <p>This is the overview page. Here you can see how the campaign is progressing</p>
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
                <button className="blue-btn modalCancelFocus cancelFocus4" onClick={hideModalTutorial}>Cancel</button>
                <button className="blue-btn tutorial-next nextFocus4 active" onClick={() => setIsOpen(true)}>Next</button> 
            </div>
            
        </div>
      </div>
      <div id="modal-open-5" className="show-desktop lightbox-panel centerPopup" aria-labelledby="tutorialProjectDetails" aria-modal="true" role="dialog">
        <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="tutorialProjectDetails">Tutorial - Project Details</h5>
            </div>
            <div className="lightbox-content padd-22">
              <p>This is the project overview page. This is the main page of every project</p>
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
                <button className="blue-btn modalCancelFocus cancelFocus5" onClick={hideModalTutorial}>Cancel</button>
                <button className="blue-btn tutorial-next nextFocus5 active" onClick={() => setIsOpen(true)}>Next</button> 
            </div>
            
        </div>
      </div>
      <div id="modal-open-6" className="show-desktop lightbox-panel centerPopup" aria-labelledby="tutorialCreateProjects" aria-modal="true" role="dialog">
        <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="tutorialCreateProjects">Tutorial - Create Project</h5>
            </div>
            <div className="lightbox-content padd-22">
              <p>But first, please give a look at the side and bottom panels</p>
            </div>
            <div className="modal-footer modal-footer-border flex px-22">
                <button className="blue-btn modalCancelFocus cancelFocus6" onClick={hideModalTutorial}>Cancel</button>
                <button className="blue-btn tutorial-next nextFocus6 active" onClick={() => setIsOpen(true)}>Next</button> 
            </div>
            
        </div>
      </div>
    </>
  );
});

Header.propTypes = {};

export default Header;
